// Module
var code = "<input-kid id=\"{{ componentId }}-{{ index }}\" ng-attr-name=\"{{ componentId }}-{{ index }}\" ng-change=\"changeValue()\" ng-disabled=\"readOnly || component.disabled\" ng-model=\"data[component.key][index].name\" ng-required=\"isRequired(component)\" options=\"component.options\" prefix=\"{{ component.kprefix }}\"></input-kid> ";
// Exports
export default code;